<template>
<div class="size mt-3 mb-1 " v-show='Loading' >
 
		<figure class="card card-sm card-product-grid " >

                
			<a href="#" class="img-wrap avatar  "> 
                
				<img class="avatar" alt="" loading="lazy">
      
			</a>
            
			<figcaption class="info-wrap" >
        <p href="#" class="brand-name title line"></p>
        <p href="#" class="brand-name title line"></p>
				<a href="#" class="price line"></a>
				<div class="mt-2">				
                </div> <!-- action-wrap.end -->
			</figcaption>
		</figure> <!-- card // -->
	</div> <!-- col.// -->
</template>

<script>
    export default {
        props: {
            Loading: {
                type: Boolean,
                default: false
            },
        },
    }
</script>

<style lang="css" scoped>
.post {
  width: 100%;
  height: 80px;
}
.card-sm .avatar {
  width: 90%;
  height: 100px;
  background-color: #ccc;
  border-radius: 0%;
  margin: 8px;
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-avatar 1.6s infinite linear;
}
.card-sm .line {
  width: 100%;
  height: 16px;
  margin-top: 12px;
  border-radius: 7px;
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-lines 1.6s infinite linear;
}
.card-sm .avatar + .line {
  margin-top: 11px;
  width: 100px;
}
.card-sm .line ~ .line {
  background-color: #ddd;
}
@keyframes shine-lines {
  0% {
    background-position: -100px;
  }
  40%, 100% {
    background-position: 140px;
  }
}
@keyframes shine-avatar {
  0% {
    background-position: -32px;
  }
  40%, 100% {
    background-position: 208px;
  }
}

.card {
    position: relative;
    display: flex;
    flex-direction: column;
    max-width: 22rem;
    max-height: 17rem;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: o.3px solid var(--main-red-black);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 1.6rem ;
    
}
.blur {
    
    position: absolute;
  width: 100vw;
  height: 100%;
  left: 0;
  top: 0;
  background: linear-gradient(180deg, #3a3a3a 7.73%, rgba(196, 196, 196, 0) 35%);
}

.brand-name{
    
    color:var(--main-black);

    font-size: .82rem;
    line-height: 1.2;
 
    
    
}
.img-wrap {
    text-align: center;
    display: contents;
  
    
}
[class*='product-'] .img-wrap img {
    height: 180px;
    width: 70%;
    display: inline-block;
    -o-object-fit: cover;
    object-fit: contain;
    margin:auto;
}
.card-product-grid .info-wrap {
    overflow: hidden;
    padding: 33px;
}

.size {
    flex: 0 0 75%;
    max-width: 75%;
    position: relative;
    width: 100%;
    padding-right: 5px;
    padding-left: 5px;
}
  @media (min-width: 1400px) and (max-width: 2600px) {
.size {
    flex: 0 0 19%;
    max-width: 20%;
    position: relative;
    width: 100%;
    padding-right: 5px;
    padding-left: 5px;
    
}
   
  }
</style>